import React from 'react';
import PropTypes from 'prop-types';

import themeable from 'zignal-landscape/lib/themeable';
import Button from 'zignal-landscape/lib/Button';
import Link from 'zignal-landscape/lib/Link';

const PageFooter = ({
  styles,
  buttonText,
  nextDisabled,
  // actions
  onFooterBack,
  onFooterCancel,
  onFooterNext
}) => {
  const cancelLink = onFooterCancel &&
    <Link onClick={onFooterCancel} linkType="cancel">Cancel</Link>;
  const backLink = onFooterBack &&
    <Link onClick={onFooterBack} data-cy="wizard-back" linkType="cancel">Back</Link>;

  let nextButton;
  if (onFooterNext) {
    nextButton = (
      <span className={styles.rightButton}>
        <Button disabled={nextDisabled} buttonStyle="secondary" data-cy="wizard-next" onClick={onFooterNext}>
          {buttonText}
        </Button>
      </span>
    );
  }

  return (
    <div className={styles.PageFooter}>
      { cancelLink }
      <span>
        { backLink }
        { nextButton }
      </span>
    </div>
  );
};

PageFooter.propTypes = {
  styles: PropTypes.object.isRequired,
  buttonText: PropTypes.string,
  nextDisabled: PropTypes.bool,
  // actions
  onFooterBack: PropTypes.func,
  onFooterCancel: PropTypes.func,
  onFooterNext: PropTypes.func
};

export default themeable(PageFooter);
